import { extractErrorMessage, categorizeError, isNetworkError } from './errorUtils'
import { toast } from 'sonner'

let setGlobalError = null

/**
 * Called by ErrorModal on mount to register its state setter.
 */
export function registerErrorHandler(handler) {
  setGlobalError = handler
}

/**
 * Show an error to the user via the appropriate channel:
 * - Network errors → toast (transient)
 * - All other errors → ErrorModal (persistent until dismissed)
 *
 * @param {Error} err - The error object (typically from a catch block)
 * @param {Object} [options]
 * @param {string} [options.title] - Override the default category title
 * @param {Function} [options.onRetry] - Optional retry callback shown as a button
 */
export function showError(err, options = {}) {
  const message = extractErrorMessage(err)

  if (isNetworkError(err)) {
    toast.error(message)
    return
  }

  const category = categorizeError(err)
  const title = options.title || category.title

  if (setGlobalError) {
    setGlobalError({ title, message, category, onRetry: options.onRetry })
  } else {
    // Fallback if ErrorModal isn't mounted yet
    toast.error(message)
  }
}
